<template>
  <li
    class="AccordionItem"
    :class="{ '-Expanded': visible }"
    ref="item"
    :data-index="index"
  >
    <div @click="open">
      <slot name="header" v-bind="{ visible }"></slot>
    </div>

    <transition
      name="accordion"
      @enter="startTransition"
      @after-enter="endTransition"
      @before-leave="startTransition"
      @after-leave="endTransition"
    >
      <div class="accordion__content" v-show="visible">
        <slot name="content"></slot>
      </div>
    </transition>
  </li>
</template>

<script>
export default {
  props: {},
  inject: ['AccordionState'],
  data() {
    return {
      index: null
    }
  },
  computed: {
    visible() {
      return this.AccordionState.active.includes(this.index)
    }
  },
  methods: {
    open() {
      if (this.visible) {
        this.AccordionState.active = this.AccordionState.active.filter(
          (i) => i !== this.index
        )
      } else {
        this.AccordionState.active.push(this.index)

        location.hash = ''
        //location.hash = '#' + this.$refs.item.getAttribute('id')

        // setTimeout(() => {

        //   window.scrollTo({
        //     behavior: 'smooth',
        //     top:
        //       this.$refs.item.getBoundingClientRect().top -
        //       document.body.getBoundingClientRect().top -
        //       5
        //   })
        // }, 50)
      }
    },

    startTransition(el) {
      el.style.height = el.scrollHeight + 'px'
    },

    endTransition(el) {
      el.style.height = ''
    }
  },
  created() {
    this.index = ++this.AccordionState.count
  }
}
</script>

<style lang="scss" scoped>
.accordion-enter-active,
.accordion-leave-active {
  will-change: height, opacity;
  // transition: height 0.2s ease, opacity 0.2s ease;
  overflow: hidden;
}

.accordion-enter-from,
.accordion-leave-to {
  height: 0 !important;
  opacity: 0;
}
</style>
